/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tr_5_AInputs */

const en_mk_tut_tr_5_a = /** @type {(inputs: Mk_Tut_Tr_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A division channel is visible only to that division, and a private channel only to those invited. Add them from the members menu on that channel.`)
};

const id_mk_tut_tr_5_a = /** @type {(inputs: Mk_Tut_Tr_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channel divisi hanya terlihat oleh anggota divisi itu, dan channel privat hanya oleh yang diajak. Tambahkan orangnya lewat menu anggota di channel tersebut.`)
};

/**
* | output |
* | --- |
* | "A division channel is visible only to that division, and a private channel only to those invited. Add them from the members menu on that channel." |
*
* @param {Mk_Tut_Tr_5_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tr_5_a = /** @type {((inputs?: Mk_Tut_Tr_5_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tr_5_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tr_5_a(inputs)
	return en_mk_tut_tr_5_a(inputs)
});